import { formatDateTime } from "@nomnom/core";
import type { Wallet, WalletTransaction } from "@nomnom/core";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../config/firebase";

export type WalletRow = Wallet & { id: string };
export type WalletTxRow = Omit<WalletTransaction, "id"> & { id: string };

export function formatTimestamp(value: Wallet["updatedAt"] | WalletTransaction["createdAt"]): string {
  return formatDateTime(value);
}

export async function loadWalletData(): Promise<{
  wallets: WalletRow[];
  transactions: WalletTxRow[];
}> {
  try {
    const walletSnap = await getDocs(collection(db, "wallets"));
    const wallets = walletSnap.docs.map((docSnap) => ({
      id: docSnap.id,
      ...(docSnap.data() as Wallet),
    }));

    const txQuery = query(
      collection(db, "walletTransactions"),
      orderBy("createdAt", "desc"),
      limit(300),
    );
    const txSnap = await getDocs(txQuery);
    const transactions = txSnap.docs.map((docSnap) => ({
      ...(docSnap.data() as Omit<WalletTransaction, "id">),
      id: docSnap.id,
    }));

    return { wallets, transactions };
  } catch (error) {
    console.error("[WalletsService] Failed to load wallet data:", error);
    throw new Error("Failed to load wallet data.");
  }
}
